export default "__VITE_ASSET__Do1rS3yv__"